module.exports = __webpack_public_path__ + "static/tetris-70e60d255783d3d5a8304b4a659af813.png";